module.exports = new __parcel__URL__("math.33efa2c8.glb").toString();